var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6797 10.4746C14.9141 10.4746 15.1094 10.5527 15.2656 10.709C15.4219 10.8652 15.5 11.0605 15.5 11.2949V14.1855C15.5 14.8366 15.2266 15.1621 14.6797 15.1621C10.7995 15.1621 7.46615 13.7689 4.67969 10.9824C1.89323 8.19596 0.5 4.86263 0.5 0.982422C0.5 0.435547 0.825521 0.162109 1.47656 0.162109H4.36719C4.60156 0.162109 4.79688 0.240234 4.95312 0.396484C5.10938 0.552734 5.1875 0.748047 5.1875 0.982422C5.1875 1.99805 5.34375 2.97461 5.65625 3.91211C5.76042 4.25065 5.69531 4.53711 5.46094 4.77148L3.85938 6.17773C5.05729 8.67773 6.97135 10.5658 9.60156 11.8418L10.8906 10.2012C11.0469 10.0449 11.2422 9.9668 11.4766 9.9668C11.6068 9.9668 11.6979 9.97982 11.75 10.0059C12.6875 10.3184 13.6641 10.4746 14.6797 10.4746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.18f2641db86e04f6bfed7d4e76f9d3a3.svg";
export { ForwardRef as ReactComponent };